/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface DownloadBulkPrintRequest$Params {
  bulkPrintRequestId: string;
}

export function downloadBulkPrintRequest(
  http: HttpClient,
  rootUrl: string,
  params: DownloadBulkPrintRequest$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, downloadBulkPrintRequest.PATH, 'get');
  if (params) {
    rb.path('bulkPrintRequestId', params.bulkPrintRequestId, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: 'text/plain', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

downloadBulkPrintRequest.PATH = '/bulk-print/{bulkPrintRequestId}/download';
